<template>
  <div class="d-flex flex-column align-items-start px-1 py-1 w-100 chart-wrapper widget">
    <slot name="title">
      <h5
        v-if="title"
        class="heading text-heavy mb-0 pl-1"
      >
        {{ title }}
      </h5>
    </slot>
    <div class="position-relative w-100 flex-fill">
      <div
        v-if="loading"
        class="loadingWrapper"
      >
        <b-spinner />
      </div>
      <bar-chart-simplified
        v-else
        :key="widgetKey"
        name="qualities"
        :data="data ? data : []"
        :value-append="valueAppend"
        height="370"
      />
    </div>
  </div>

</template>

<script>
import BarChartSimplified from '@/components/charts/bar-chart/BarChartSimplified.vue'

export default {
  name: 'BarWidget',
  components: {
    BarChartSimplified,
  },
  props: {
    widgetKey: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: null,
    },
    valueAppend: {
      type: String,
      default: '',
    },
  },
  computed: {
    isEmpty() { return !this.data.some(el => el.count > 0) },
  },
}
</script>
